<!--
 * @Author: your name
 * @Date: 2021-05-06 17:30:52
 * @LastEditTime: 2021-06-02 10:24:32
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \xingmahui_front\src\views\contents\eat\categoryList.vue
-->
<template>
    <div class='category-container'>
        <!-- 搜索 -->
        <div class="search_">
            <span class="back" @click="goBack">
                <van-icon name="arrow-left" />
            </span>
             <van-search
                class="vanSearch"
                v-model="searchText"
                placeholder="请输入食物名称"
                shape="round"
                @focus="searchFocus($event)"
            >
                <template v-slot:left-icon>
                <img class="search-img" src="@/assets/images/icon/search.png" />
                </template>
            </van-search>
        </div>

        <!-- 分类食物列表 -->
        <div class="classified-food">
            <van-list
                v-model="eatListLoading"
                :finished="eatListFinished"
                finished-text="——已经到底了哦——"
                :error.sync="eatListError"
                error-text="请求失败，点击重新加载"
                @load="onLoad"
            >
                <!-- <listItem :list="eatAnswerList"  @goFoodDetails="goFoodDetails"></listItem> -->
                <ExcellentSelect v-for="(item, index) in eatAnswerList" :key="index"
                    @handleRecommendFn="goFoodDetails"
                    :item="item"
                    :id="item.id">
                    <div class="introduction" slot="nape">
                      {{item.introduction}}
                    </div>
                </ExcellentSelect>
            </van-list>
        </div>



    </div>
</template>

<script>
import listItem from '@/views/canEatList/components/listItem.vue';
import { Exposurer_eatToolsClass } from '@/assets/js/Exposure'
import { getCookie, is_weixin } from "@/assets/js/common.js";
import ExcellentSelect from './components/ExcellentSelect'
import API from "@/utils/axiosApi/canEatApi"
export default {
    name: "categoryList",
    data() {
        return {
            searchText: '',// 输入框文案
            eatAnswerList: [],// 分类食物列表
            eatListLoading: false,// 分类食物列表
            eatListFinished: false,// 分类食物列表
            eatAnswerParams: {// 分页参数
                size: 10,
                page: 1,
                id: 1,
                data:{
                    dingZhi:true,
                    phase:0,
                }
            },
            eatListError: false,
        }
    },
    beforeRouteEnter (to, from, next) {
    next(vm => {
        //   vm.getUserLog()
        vm.$store.commit("changeIncludes", ["categoryList"]);
        if (vm.is_weixin()) {//微信中
            if (vm.getCookie("xmh_openid") == null || vm.getCookie("xmh_openid") == "") {//判断有没有openId
                location.href = "/xmh/v2/wechat/oauth2/authorize?url=" + encodeURIComponent(window.location.href);
            } else {
            vm.userOpenid = vm.getCookie('xmh_openid')
            vm.UserInfo = JSON.parse(localStorage.getItem('userInfo'));
            vm.wxJsSet.getUserInfoBywx(vm, function () {
                vm.UserInfo = JSON.parse(localStorage.getItem('userInfo'));
                gio('setUserId', vm.UserInfo.crm_id);
                if (vm.UserInfo.mobile == null || vm.UserInfo.mobile == "" || vm.UserInfo.mobile == "null") {//没有手机号未注册
                sensors.login(vm.getCookie('xmh_unionid'))
                vm.profileShow = false;
                vm.loginShow = true;
                // vm.getUserLog()
                } else {
                vm.UserInfo = JSON.parse(localStorage.getItem('userInfo'));
                sensors.login(vm.UserInfo.crm_id)
                if (vm.UserInfo.mobile == vm.UserInfo.full_name) {
                    if (vm.getCookie('xmh_nickname') == '') {
                    vm.userName = vm.UserInfo.full_name
                    } else {
                    vm.userName = vm.getCookie('xmh_nickname')
                    }
                } else {
                    vm.userName = vm.UserInfo.full_name
                }
                vm.profileShow = true;
                vm.loginShow = true;
                // vm.initPage();
                }
            }, function () {
                if (vm.UserInfo == null || vm.UserInfo == "" || vm.UserInfo.mobile == null || vm.UserInfo.mobile == "" || vm.UserInfo.mobile == "null") {//没有手机号未注册
                sensors.login(vm.getCookie('xmh_unionid'))
                vm.profileShow = false;
                vm.loginShow = true;
                vm.$router.replace('/canEatList');
                // location.href = "/canEatList";
                //   vm.getUserLog()
                } else {
                vm.UserInfo = JSON.parse(localStorage.getItem('userInfo'));
                sensors.login(vm.UserInfo.crm_id)
                if (vm.UserInfo.mobile == vm.UserInfo.full_name) {
                    if (vm.getCookie('xmh_nickname') == '') {
                    vm.userName = vm.UserInfo.full_name
                    } else {
                    vm.userName = vm.getCookie('xmh_nickname')
                    }
                } else {
                    vm.userName = vm.UserInfo.full_name
                }
                vm.profileShow = true;
                vm.loginShow = true;
                // vm.initPage();
                }
            });
            }
        } else {
            vm.UserInfo = JSON.parse(localStorage.getItem('userInfo'));
            if (vm.getCookie("xmh_phone") == null || vm.getCookie("xmh_phone") == "" || vm.UserInfo == null || vm.UserInfo == "") {//未登录
            sensors.login(vm.getCookie('xmh_unionid'))
            vm.profileShow = false;
            vm.loginShow = true;
            //   vm.getUserLog()
            } else {
            sensors.login(vm.UserInfo.crm_id)
            if (vm.UserInfo.mobile == vm.UserInfo.full_name) {
                if (vm.getCookie('xmh_nickname') == '') {
                vm.userName = vm.UserInfo.full_name
                } else {
                vm.userName = vm.getCookie('xmh_nickname')
                }
            } else {
                vm.userName = vm.UserInfo.full_name
            }
            vm.profileShow = true;
            vm.loginShow = true;
            // vm.initPage();
            }
        }
        // vm.UserInfo = JSON.parse(localStorage.getItem('userInfo'));
        // var isPageHide = false;
        // window.addEventListener('pageshow', function () {
        //     if (isPageHide) {
        //     vm.getUserRole()
        //     }
        // });
        // window.addEventListener('pagehide', function () {
        //     isPageHide = true;
        // })
    })
    },
    components: {
      ExcellentSelect,
      listItem
    },
    mounted() {
        if(localStorage.getItem('babyNum')==0){
            this.eatAnswerParams.data.dingZhi=false
        }
        this.eatAnswerParams.data.phase=localStorage.getItem('monthAge')?localStorage.getItem('monthAge'):''
        document.title = this.$route.query.name
        this.eatAnswerParams.id = this.$route.query.classifyId || 2

        var shareDataParams = {
            shareLink: location.href.split('#')[0] + "&isGod=foodGroups&isFood=UnShelve",
            shareDesc: "快来星妈会找找答案吧！",
            shareTitle: "孕育女性/小孩/老人，该怎么吃这些"+ this.$route.query.name +"?",
            imgUrl: "https://image-mom.feihe.com/wxshare/home.png" //必须是绝对路径
        };
        this.wxJsSet.wxShare("fx", shareDataParams, this);

        setTimeout(() => {
          const data = JSON.parse(localStorage.getItem("toolEatPoint")) || {};
          Exposurer_eatToolsClass.observe('.category-container', false, {
            Pregnancy_Weeks: data.Pregnancy_Weeks,
            Baby_Month: data.Baby_Month,
            Gestate_State: data.Gestate_State,
            Visit_Channel: data.Visit_Channel,
            Classification_Name: this.$route.query.name,
            module_name:'能不能吃',
            per_page_name:'能不能吃',
            per_module_name:'能不能吃'
          })
        }, 2000)

    },
    methods: {
        is_weixin, getCookie,
        // 返回上一页
        goBack: function () {
            this.$route.query.isGod? this.$router.push("/home"): this.$router.go(-1);
        },

        // 搜索框获取焦点
        searchFocus: function (e) {
            sensors.track('Eatable_ClickSearch', {
                page_name: '食物列表',
                module_name:'能不能吃',
                per_page_name:'能不能吃',
                per_module_name:'能不能吃'
            })
            setTimeout(() => {
                this.$router.push({ path: '/canEatListSearch', query: { title: this.$route.query.name } })
            }, 200)

        },
        /**
         * @description 跳转食物详情页
         * @param id 食物分类标识
         */
        goFoodDetails(id,name) {
            // 黑白榜页面，点击食物列表时触发<食物名称>
            sensors.track("Eatable_ClassifiedFood_Click", {
                FoodName: name,
                module_name:'能不能吃',
                per_page_name:'能不能吃',
                per_module_name:'能不能吃'
            });
            // localStorage.setItem("nbncgory_scTop", this.scTop);
            setTimeout(() => {
                this.$router.push('/canEatDetail/'+id+'?nape='+name)
            }, 200);
        },
        onLoad() {
            API.onCategoryListLoad(
                {},
                {
                ...this.eatAnswerParams
                },
                res => {
                    this.eatListLoading = false;
                    if (res.code == 200) {
                        // 从外部进入时,食物处于下架或删除状态
                        !(!this.$route.query.isGod || !res.data.content.length==0 && !res.data.state==1)? this.$router.replace('/canEatList?isShare=categoryList'): ''

                        this.eatAnswerList = this.eatAnswerList.concat(
                            res.data.content
                        );
                        console.log(this.eatAnswerList);

                        if (
                        res.data.content.length < 10
                        ) {
                        this.eatListFinished = true;
                        this.finishText = "——已经到底了哦——";
                        } else {
                        this.eatAnswerParams.page += 1;
                        }

                    } else {
                        this.eatListLoading = false;
                        this.eatListError = true;

                    }
                }
                // res => {
                //     this.eatListLoading = false;
                //     this.eatListError = true;
                // }
            );
        },
    },
    activated() {
        document.title = this.$route.query.name
    },
}
</script>

<style scoped lang='less'>
.introduction {
              width: 100%;
              background: #FFFFFF;
              display: -webkit-box;
              overflow: hidden;
              // autoprefixer: off;
              // autoprefixer: on;
              word-break: break-all;
              -webkit-box-orient: vertical;
              text-overflow: ellipsis;
              -webkit-line-clamp: 1;
              font-size: 12px;
              color: #999999;
              height: 19px;
              line-height: 26px; // 下面icons给margin边距这里得+margin: 7;
              font-weight: 500;
}

.category-container {
    padding-top: 58px;
    min-height: calc(100% - 58px);
    background: #f7f7f7;
}
/deep/ .van-list__finished-text {
    padding: 12px 0;
    background: #f7f7f7;
}
// 搜索
/deep/ .van-field__value {
  padding-left: 14px;
}
/deep/ .van-field__control {
  line-height: 23px;
}
.search-img {
  width: 14px;
  position: absolute;
  top: 50%;
  margin-top: -9px;
}
.search_ {
  width: 100%;
  background: @expertFontColor255;
  overflow: hidden;
  padding-bottom: 12px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 98;
  .back {
    float: left;
    font-size: @indexFontSize20;
    padding-top: 19px;
    width: 22px;
    text-align: right;
    padding-left: 5px;
  }

  .van-search {
    width: 91%;
    padding: 13px 0 0 12px;
    font-size: @indexFontSize12;
    float: left;
    .van-search__action {
      padding: 0 12px;
      font-size: @indexFontSize14;
    }
  }
  .vanSearch1 {
    width: 90%;
    padding: 12px 0 0 12px;
  }
  @media screen and (max-width: 640px) {
    .vanSearch1 {
      width: 316px;
    }
  }
}

// 分类食物列表
.classified-food {
    background: #F7F7F7;
    padding: 10px 12px 13px;
    // .classified-list {
    //     background: #fff;
    //     border-radius: 8px 8px 0 0;
    //     padding-left: 10px;
    //     .food-list {
    //         position: relative;
    //         .title {
    //             line-height: 22px;
    //             color: #333333;
    //             font-size: 16px;
    //             padding: 13px 0 7px 0;
    //             font-weight: 500;
    //             line-height: 16px;
    //             >span {
    //                 font-size: 12px;
    //                 line-height: 1;
    //                 color: #888;
    //             }
    //         }
    //         .title-depict {
    //             width: 216px;
    //             line-height: 12px;
    //             color: #999999;
    //             overflow: hidden;
    //             white-space: nowrap;
    //             text-overflow: ellipsis;
    //             padding-bottom: 14px;
    //             padding-top: 1px;
    //         }
    //         .period-details {
    //             font-size: 14px;
    //             display: flex;
    //             padding-bottom: 8px;
    //             .letters {
    //                 height: 20px;
    //                 display: flex;
    //                 align-items: center;
    //                 >span {
    //                     // display: inline-block;
    //                     margin-left: 3px;
    //                     margin-right: 60px;
    //                 }

    //                 .checked {
    //                     display: inline-block;
    //                     width: 14px;
    //                     height: 14px;
    //                     background: url('../../assets/images/canEat/0.png') no-repeat  left / 100%;
    //                 }

    //                 .more {
    //                     display: inline-block;
    //                     width: 14px;
    //                     height: 14px;
    //                     background: url('../../assets/images/canEat/1.png') no-repeat  left / 100%;
    //                 }

    //                 .warning {
    //                     display: inline-block;
    //                     width: 14px;
    //                     height: 14px;
    //                     background: url('../../assets/images/canEat/2.png') no-repeat  left / 100%;
    //                 }

    //                 .clear {
    //                     display: inline-block;
    //                     width: 14px;
    //                     height: 14px;
    //                     background: url('../../assets/images/canEat/3.png') no-repeat  left / 100%;
    //                 }

    //             }
    //         }
    //         .food-border {
    //             width: 95px;
    //             height: 70px;
    //             // background: #ccc;
    //             // background-repeat: no-repeat;
    //             // background-size: cover;
    //             position: absolute;
    //             right: 10px;
    //             bottom: 20px;
    //             border: 1px solid #EEEEEE;
    //             border-radius: 4px;
    //             .food-img {
    //                 width: 62px;
    //                 height: 58px;
    //                 margin: 6px auto;
    //                 background-repeat: no-repeat;
    //                 background-size: 100% 100%;
    //             }
    //         }
    //         .dividing-line {
    //             width: 100%;
    //             height: 1px;
    //             background: #F2F2F2;
    //             margin-top: 12px;
    //         }
    //     }

    // }

}

// /deep/ .van-list__finished-text {
//     padding: 77px 0 18px 0;
//     background: #fff;
//     border-radius: 0 0 8px 8px;
// }
</style>